import React, { useContext } from 'react'
import { Hydrator } from '@usap/core'
import { LocalContext } from '../../../helpers/useLocalContext'
import Article from './Article.component'

const ArticleLazyLoader = ({ pageTransition, ...props }) => {
  const { localContext } = useContext(LocalContext)
  const { isBot } = localContext

  return (
    <Hydrator
      Component={Article}
      lazy={!pageTransition && !isBot}
      {...props}
    />
  )
}

export default ArticleLazyLoader
